import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import './style.scss';
import { DefaultIcon, GradientIcon } from '../../../atoms/icons';

interface Props {
    icon: React.ReactElement<DefaultIcon> | React.ReactElement<GradientIcon>;
    title: string;
    show: boolean;
    currentPath: string; // current url
}

const Link: React.FC<Props> = (props) => {
  const {
    icon, title, show, currentPath,
  } = props;
  const modifiedTitle = title.toLowerCase().replace(' ', '-');
  const url = `/${modifiedTitle}`;

  return (
    <button
      type="button"
      className="bg-transparent border-0 w-100"
    >
      <RouterLink to={url} className="text-decoration-none">
        <div className={`${currentPath === modifiedTitle ? '' : 'opacity-40'} navLink`}>
          <div className="icon">
            <div>{icon}</div>
          </div>
          <div className={`title ${!show ? 'd-none' : ''}`}>{title}</div>
        </div>
      </RouterLink>
    </button>
  );
};

export default Link;
